module.exports = __webpack_public_path__ + "static/media/sale.f97238d1.svg";